'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactFela = require('react-fela');

var ScrollView = function ScrollView(props) {
  return {
    overflowY: props.horizontal ? 'hidden' : 'auto',
    overflowX: props.horizontal ? 'auto' : 'hidden',
    WebkitOverflowScrolling: 'touch',
    height: props.height || '100%',
    width: props.width || '100%',
    flex: props.flex
  };
};

exports.default = (0, _reactFela.createComponent)(ScrollView);
module.exports = exports['default'];